import FlightDetailsAncillaryItem from "../../../../components/elements/FlightDetailsAncillaryItem/FlightDetailsAncillaryItem";
import { HealthInsuranceIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { t } from "@bookingcom/lingojs-core";
import React, { useMemo } from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import { UIProductTravelInsurance } from "@flights/types";
import useFormatPrice from "../../../../hooks/useFormatPrice";
import usePointOfSale from "../../../../hooks/usePointOfSale";

type Props = {
  travelInsurance: UIProductTravelInsurance;
  showLoadingPrice?: boolean;
  /* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
  condensedFDDesktop?: boolean;
  condensedFDMobile?: boolean;
  /* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
  /* start - flights_apex_web_remove_price_qualifier_for_solo_traveler_fd */
  hideQualifier?: boolean;
  /* end - flights_apex_web_remove_price_qualifier_for_solo_traveler_fd */
};

const InsuranceItem = ({
  travelInsurance,
  showLoadingPrice,
  condensedFDDesktop,
  condensedFDMobile,
  hideQualifier
}: Props) => {
  const i18n = useI18n();
  const { formatPrice } = useFormatPrice();
  const pointOfSale = usePointOfSale() || "";

  const title = useMemo(() => {
    if (travelInsurance.content?.header) return travelInsurance.content.header;
    if (["nz", "au"].includes(pointOfSale)) return i18n.trans(t("flights_apex_fd_travel_protection_title"));
    if (["mx", "co", "cl", "pe"].includes(pointOfSale)) return i18n.trans(t("flights_apex_fd_travel_assitance_title"));
    if (["ca", "ch"].includes(pointOfSale)) return i18n.trans(t("flights_apex_fd_travel_insurance_title"));
    if (["kr"].includes(pointOfSale)) return i18n.trans(t("flights_apex_cover_insurance_south_korea_title"));
    return i18n.trans(t("flights_apex_travel_protection_title"));
  }, [travelInsurance, pointOfSale, i18n]);

  const description = useMemo(() => {
    if (pointOfSale === "kr") return i18n.trans(t("flights_apex_fd_med_insurance_description_travel"));
    return i18n.trans(t("flights_apex_fd_insurance_description_travel"));
  }, [pointOfSale, i18n]);

  const { priceBreakdown } = travelInsurance.options;
  const insurancePrice = formatPrice(priceBreakdown.total);

  const insurancePriceCopy = travelInsurance.isPerTraveller
    ? hideQualifier
      ? i18n.trans(t("flights_fd_insurance_price_solo", { variables: { price_diff: insurancePrice } }))
      : i18n.trans(t("flights_apex_fd_insurance_price_pp", { variables: { price: insurancePrice } }))
    : i18n.trans(t("flights_apex_insurance_price_all_travellers", { variables: { price: insurancePrice } }));

  return (
    <FlightDetailsAncillaryItem
      type="travelInsurance"
      icon={HealthInsuranceIcon}
      showLoadingPrice={showLoadingPrice}
      title={title}
      description={description}
      priceCopy={insurancePriceCopy}
      /* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
      condensedFDDesktop={condensedFDDesktop}
      condensedFDMobile={condensedFDMobile}
      /* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
    />
  );
};

export default InsuranceItem;
